import { render } from "./comingsoon_timer.vue?vue&type=template&id=e1179c02"
import script from "./comingsoon_timer.vue?vue&type=script&lang=js"
export * from "./comingsoon_timer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__